/* eslint-disable */
import React, { useState } from 'react';
import {
  displayErrorMessage,
  displaySuccess,
} from 'Helpers/FacetNotificationManager';
import { makeStyles } from '@material-ui/core/styles';
import useResource from 'Hooks/useResource';
import Button from '@material-ui/core/Button';
import MetaControl from 'Components/UI/Meta/MetaControl';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

const useStyles = makeStyles(theme => ({
  field: {
    marginRight: theme.spacing(0.75),
  },
  address: {
    '& > .MuiInputBase-root': {
      width: '23ch',
      fontSize: theme.typography.body1.fontSize,
    },
    '& > .MuiInputBase-root > .MuiInputBase-input': {
      fontSize: theme.typography.body1.fontSize,
    },
  },
  type: {
    width: '7ch',
    '& > .MuiInputBase-root': {
      fontSize: theme.typography.body1.fontSize,
    },
    '& > .MuiInputBase-root > .MuiInputBase-input': {
      fontSize: theme.typography.body1.fontSize,
    },
  },
  save: {
    padding: '2px',
    borderRadius: '50px',
    width: '10px',
    backgroundColor: theme.palette.facet.primaryGray,
    color: theme.palette.facet.lightGray,
  },
  disabledButton: {
    padding: '2px',
    borderRadius: '50px',
    width: '10px',
    '&.Mui-disabled': {
      backgroundColor: theme.palette.secondary.main,
      color: theme.palette.facet.lightGray,
    },
  },
  emailFormControls: {
    display: 'flex',
    alignItems: 'center',
    alignContent: 'center',
  },
  spacer: {
    flexGrow: 1,
  },
}));

export default function EmailAddressForm({
  emailAddressResource,
  onSubmit,
  onDelete,
  validateSubmission,
}) {
  const classes = useStyles();
  const { resource, setAttribute } = useResource(emailAddressResource);
  const [changed, setChanged] = useState(false);

  const handleUpdate = (attrName, v) => {
    setChanged(true);
    setAttribute(attrName, v);
  };

  const handleSave = () => {
    if (!validateSubmission || validateSubmission(resource)) {
      resource
        .submit()
        .then(() => displaySuccess('Successfully saved email address'))
        .then(() => setChanged(false))
        .then(() => onSubmit && onSubmit())
        .catch(err => {
          displayErrorMessage(err, err.errors);
        });
    }
  };

  return (
    <div className={classes.emailFormControls}>
      {resource
        .meta()
        .template()
        .list()
        .map((field, i) => (
          <MetaControl
            key={`control.${i}`} // eslint-disable-line react/no-array-index-key
            attrName={field.attr('name')}
            onChange={value => handleUpdate(field.attr('name'), value)}
            className={classNames(classes.field, classes[field.attr('name')])}
            disabled={resource.attr('isActive') !== 'true'}
            resource={resource}
          />
        ))}
      <span>
        {resource.attr('isActive') === 'true' && (
          <Button
            className={changed ? classes.save : classes.disabledButton}
            size="small"
            disabled={!changed}
            variant="contained"
            onClick={handleSave}
          >
            {changed ? 'Save' : 'Saved'}
          </Button>
        )}
      </span>
      <span>
        {resource.attr('isActive') === 'true' &&
          resource.attr('isPrimary') !== 'true' && (
            <IconButton
              size="small"
              onClick={onDelete}
            >
              <DeleteIcon />
            </IconButton>
          )}
      </span>
    </div>
  );
}
